'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import PropTypes from 'prop-types';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { EERIE, BUTTON_DISABLED_TEXT, OBSIDIAN } from 'HubStyleTokens/colors';
import styled from 'styled-components';
const MiniIcon = styled(UIIcon).withConfig({
  displayName: "TabTitle__MiniIcon",
  componentId: "kzdh9m-0"
})(["position:absolute;bottom:-10px;right:5px;font-size:0.6em;color:", " !important;"], OBSIDIAN);

class TabTitle extends PureComponent {
  renderIcon() {
    if (!this.props.iconName) return null;

    if (this.props.isLocked) {
      return /*#__PURE__*/_jsxs("div", {
        className: "file-tab-icon",
        style: {
          position: 'relative'
        },
        children: [/*#__PURE__*/_jsx(UIIcon, {
          color: BUTTON_DISABLED_TEXT,
          name: this.props.iconName,
          size: 18
        }), /*#__PURE__*/_jsx(MiniIcon, {
          name: "locked"
        })]
      });
    }

    return /*#__PURE__*/_jsx(UIIcon, {
      name: this.props.iconName,
      size: 18,
      className: "file-tab-icon"
    });
  }

  renderLabel() {
    const {
      label,
      hasBufferedChanges
    } = this.props;
    const className = 'tab-title-label' + (hasBufferedChanges ? " has-buffered-changes" : "");
    return /*#__PURE__*/_jsx("span", {
      className: className,
      children: /*#__PURE__*/_jsx(UITruncateString, {
        useFlex: true,
        tooltip: false,
        children: label
      })
    });
  }

  renderCloseIcon() {
    const {
      closable,
      isPinned,
      onClose,
      onPinClick
    } = this.props;
    if (!closable) return null;

    if (isPinned) {
      return /*#__PURE__*/_jsx(UIIcon, {
        name: "pin",
        size: 18,
        onClick: onPinClick
      });
    }

    return /*#__PURE__*/_jsx(UIIcon, {
      className: "file-tab-close-icon",
      name: "remove",
      color: EERIE,
      onClick: onClose,
      size: 10
    });
  }

  render() {
    return /*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      className: "file-tab-title",
      direction: "row",
      justify: "start",
      wrap: "nowrap",
      children: [this.renderIcon(), this.renderLabel(), this.renderCloseIcon()]
    });
  }

}

TabTitle.propTypes = {
  closable: PropTypes.bool,
  iconName: PropTypes.string,
  onClose: PropTypes.func,
  hasBufferedChanges: PropTypes.bool.isRequired,
  label: PropTypes.node.isRequired,
  isLocked: PropTypes.bool.isRequired,
  isPinned: PropTypes.bool.isRequired,
  onPinClick: PropTypes.func.isRequired
};
TabTitle.defaultProps = {
  closable: true,
  onClose: emptyFunction
};
export default TabTitle;